import { useParams } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { useGetQuotationFormConfig } from "api/queries/quotation-form/useGetQuotationFormConfig";
import FormHr from "pages/shipper/RequestForm/components/Common/FormHr";
import FlightForm from "./FlightForm";
import VesselForm from "./VesselForm";

export default function StopFlightAndVesselSection() {
  const id = useParams().id?.toUpperCase();
  const { data: quotationConfigData } = useGetQuotationFormConfig(id!, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const { getValues } = useFormContext();
  const selectedFreightModeData = quotationConfigData?.freight_modes?.find(
    (item: any) => item.value === getValues("service.freight_mode"),
  );

  const isOceanFreight =
    ["ocean_freight"].includes(getValues("service.freight_mode")) || selectedFreightModeData?.type === "ocean";
  const isAirCharter = ["air_charter"].includes(getValues("service.freight_mode"));
  const isAirFreight =
    ["obc", "nfo", "regular_air"].includes(getValues("service.freight_mode")) ||
    (selectedFreightModeData?.type === "air" && !isAirCharter);

  if (!isOceanFreight && !isAirFreight) return null;
  return (
    <>
      <div className="flex-row my-3xl">
        <div className="w-300 pr-16">
          <h6>
            {isOceanFreight && <FormattedMessage id="quote.provider.vesselDetails" defaultMessage="Vessel details" />}
            {isAirFreight && <FormattedMessage id="quote.provider.flightDetails" defaultMessage="Flight details" />}
          </h6>
        </div>
        <div>{isAirFreight ? <FlightForm /> : <VesselForm />}</div>
      </div>
      <FormHr />
    </>
  );
}
